/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { useEffect } from 'react';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection, MenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { MENU_ID_PROJECTS_VIEW_ALL_STARRED } from '@jira/navigation-apps__sidebar-nav4-context/src/common/constants.tsx';
import { Nav4MenuLinkItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/ui/nav4-menu-link-item/index.tsx';
import { ProjectsDroppableGroupIndicator } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-customise-order/src/ui/droppable-group-indicator/index.tsx';
import { useProjectsAnalyticsL2 } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/controllers/use-projects-analytics-l2/index.tsx';
import { STARRED_SECTION } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/project-content-section.tsx';
import type { FavoriteItemsType } from '../types.tsx';

const starred = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.starred',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Starred',
	description: 'Message for starred heading in the projects menu items',
});

const viewAllStarred = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.content.view-all-starred',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'View all starred',
	description: 'Message for view all starred link in the starred projects section',
});

const VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';

export function RenderStarredSection({
	favoriteItems,
	canCreateProject,
}: {
	favoriteItems: FavoriteItemsType;
	canCreateProject: boolean | undefined | null;
}): false | React.JSX.Element {
	const { formatMessage } = useIntl();
	const { sendProjectMenuContentSectionAnalyticsEvent } = useProjectsAnalyticsL2();

	useEffect(() => {
		sendProjectMenuContentSectionAnalyticsEvent({
			projectSection: STARRED_SECTION,
			canCreateProject,
		});
	}, [canCreateProject, sendProjectMenuContentSectionAnalyticsEvent]);

	return (
		favoriteItems.hasItems && (
			<ProjectsDroppableGroupIndicator>
				{/* eslint-disable-next-line jira/integration/test-id-by-folder-structure */}
				<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.starred-section.starred-section">
					<MenuSection>
						<MenuSectionHeading>{formatMessage(starred)}</MenuSectionHeading>
						<MenuList>{favoriteItems.list}</MenuList>
					</MenuSection>
				</MenuListItem>
				{favoriteItems.hasNextPage && (
					<Nav4MenuLinkItem href={VIEW_ALL_STARRED_HREF} menuId={MENU_ID_PROJECTS_VIEW_ALL_STARRED}>
						{formatMessage(viewAllStarred)}
					</Nav4MenuLinkItem>
				)}
			</ProjectsDroppableGroupIndicator>
		)
	);
}
